export const INIT_INTERACTION_GALAXY = "INIT_INTERACTION_GALAXY";
export const INIT_INTERACTION_SUCCESS = "INIT_INTERACTION_SUCCESS";
export const INIT_INTERACTION_BY_TABLE_SUCCESS = "INIT_INTERACTION_BY_TABLE_SUCCESS";
export const INIT_INTERACTION_GLOBAL = "INIT_INTERACTION_GLOBAL";
export const INIT_INTERACTION_BY_TABLE = "INIT_INTERACTION_BY_TABLE";
export const CONTEXTUALIZE = "CONTEXTUALIZE";
